import React, { lazy } from 'react';
import { useParams, Navigate } from 'react-router-dom';
import { CheckCircle2Icon, PhoneIcon } from 'lucide-react';
import { PageHero } from '../components/ui/PageHero';
import { SERVICES, COMPANY } from '../lib/site';
import { Reveal } from '../components/fx/Reveal';
import { MagneticButton } from '../components/fx/MagneticButton';
import { EmergencyCTA } from '../components/sections/EmergencyCTA';
import { ServiceCard } from '../components/ui/ServiceCard';
import { SectionHeading } from '../components/ui/SectionHeading';
import { PROJECTS } from '../lib/site';
const benefits = ['Certified, insured specialists on every job', 'Advanced equipment for fast, thorough results', 'Direct insurance claim coordination', 'Transparent scope and pricing upfront', 'Luxury-grade finish and craftsmanship', "Ongoing support until you're fully satisfied"];
export function ServiceDetail() {
  const {
    slug
  } = useParams();
  const service = SERVICES.find(s => s.slug === slug);
  if (!service) return <Navigate to="/services" replace data-id="element-531" data-mp="18gqa8n4e84dg" />;
  const Icon = service.icon;
  const related = SERVICES.filter(s => s.slug !== service.slug).slice(0, 4);
  return <>
      <PageHero eyebrow={service.emergency ? '24/7 Emergency Service' : 'Service'} title={service.title} subtitle={service.description} crumbs={[{
      label: 'Home',
      to: '/'
    }, {
      label: 'Services',
      to: '/services'
    }, {
      label: service.title
    }]} data-id="element-532" data-mp="zgbnrkfp0j8d" />

      <section className="mx-auto max-w-7xl px-6 py-16" data-id="element-533" data-mp="fslypkz54x2u">
        <div className="grid items-start gap-12 lg:grid-cols-2" data-id="element-534" data-mp="fu5g5ewj9e67">
          <Reveal data-id="element-535" data-mp="ksgr5sykduq0">
            <div className="overflow-hidden rounded-[2.5rem] shadow-glow" data-cursor="image" data-id="element-536" data-mp="krylk5q0i45f">
              <img src={PROJECTS[0].image} alt={service.title} loading="lazy" decoding="async" className="h-[420px] w-full object-cover" data-id="element-537" data-mp="bqr0wqgf51tt" />
            </div>
          </Reveal>
          <div data-id="element-538" data-mp="28nvcf9zclau0">
            <Reveal data-id="element-539" data-mp="28nd7zq2j7qb0">
              <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-royal/10 text-royal" data-id="element-540" data-mp="23pttqq5u3dj2">
                <Icon className="h-8 w-8" strokeWidth={1.8} data-id="element-541" data-mp="1zp1ixshbd0ko" />
              </div>
            </Reveal>
            <Reveal delay={0.1} data-id="element-542" data-mp="2wfah39elk48f">
              <h2 className="mt-6 font-display text-2xl font-bold text-navy sm:text-3xl" data-id="element-543" data-mp="2we8wad7s43di">
                Why homeowners choose Dream Shield
              </h2>
              <p className="mt-4 text-base leading-relaxed text-slate" data-id="element-544" data-mp="2ndks0a86thdt">
                {service.description}
              </p>
            </Reveal>
            <ul className="mt-8 grid gap-3 sm:grid-cols-2" data-id="element-545" data-mp="2ieq10l02gmim">
              {benefits.map((b, i) => <Reveal key={b} delay={0.1 + i * 0.06} data-id="element-546" data-mp="1c08mluws4qpj" data-mpi={i}>
                  <li className="flex items-start gap-3 text-sm font-medium text-navy" data-id="element-547" data-mp="16zkuf5wte3tq">
                    <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-success" data-id="element-548" data-mp="3inppoqlxxt5d" />
                    {b}
                  </li>
                </Reveal>)}
            </ul>
            <Reveal delay={0.3} className="mt-10 flex flex-wrap gap-4" data-id="element-549" data-mp="3ro4cxvigtibi">
              <MagneticButton variant="primary" to="/contact" data-id="element-550" data-mp="3rm1dkkvfacu4">
                Schedule Free Inspection
              </MagneticButton>
              <MagneticButton variant="emergency" href={COMPANY.phoneHref} data-id="element-551" data-mp="58t4isfjkdgv">
                <PhoneIcon className="h-4 w-4" data-id="element-552" data-mp="a7e2smb8gn2o" /> Call Now
              </MagneticButton>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-16" data-id="element-553" data-mp="f7sbm6kns11r">
        <SectionHeading eyebrow="Explore More" title="Related Services" data-id="element-554" data-mp="j7srlvneokax" />
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4" data-id="element-555" data-mp="j5q53llgp9ay">
          {related.map((s, i) => <ServiceCard key={s.slug} service={s} index={i} data-id="element-556" data-mp="2kzfogdtzb9fb" data-mpi={i} />)}
        </div>
      </section>

      <EmergencyCTA data-id="element-557" data-mp="1pp9565gix7bb" />
    </>;
}